import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  ClaimProductState,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/issue`;

interface SetIssueForClaimArgs {
  claimId: string;
  issueId: string;
}

const setIssueForClaim = async ({
  claimId,
  issueId,
}: SetIssueForClaimArgs): Promise<
  BackResponse<ClaimProductState> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId);

    const response = await apiCall<BackResponse<ClaimProductState>>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        issueId,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default setIssueForClaim;
